<template>
  <div>
    <a
      :href="destination"
      :title="title"
      :style="style"
      target="_self"
      class="customButton btn"
      >{{ title }}</a
    >
  </div>
</template>

<script>
export default {
  props: {
    areaId: {
      type: Number,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    fontSize: {
      type: Number,
      required: true
    },
    textColor: {
      type: String,
      required: true
    },
    fontWeight: {
      type: Number,
      required: true
    },
    backgroundColor: {
      type: String,
      required: true
    },
    destination: {
      type: String,
      required: true
    }
  },
  computed: {
    style() {
      return `
        background-color: ${this.backgroundColor};
        color: ${this.textColor};
        font-size: ${this.fontSize}px;
        font-weight: ${this.fontWeight};
      `;
    }
  }
};
</script>

<style scoped>
.customButton {
  border: none;
  padding: 10px 20px;
  margin: 5px 0px;
  border-radius: 3px;
  text-decoration: none !important;
  text-align: center;
  max-width: 150px;
  width: 100%;
}
.customButton:hover {
  opacity: 0.8;
  text-decoration: none;
}
</style>
